import { FileService } from './../../../shared/services/fileService';
import { FileUploader } from './fileUploadModal';
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Configuration, HttpClientCustom} from "../../../shared";
@Component({
    selector: 'recordFormat',
    templateUrl: 'recordFormat.component.html'
})

export class RecordFormatComponent {
    downloadUrl: string = this._global.get('EPMS_BASE_URL') + "v1/biAdmin/" + BiUrls.DOWNLOAD_DRILL_FILE;
    public recordFormatReg: string = '';
    public sPage: number = 0;
    public lastRegex: string = '';
    public recordData: any = {
        id: null, name: '', recordFormatCode: null,
        description: '', deleted: 0
    };
    public mainPage: boolean = true;
    public recordPage: boolean = false;
    public recordList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public recordFormatFieldData: any = [];
    public recordFormatData: any = {};
    public showField: boolean = false;

    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedRFId: number;
    public endingPage: number;
    public totalRecords: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;
    public dataSourceList: any = [];
    public isFieldEdit : any = [];
    public errorIndexF : number;
    public errorIndexD : number;



    constructor(
        public recordService: MDMService, public toastr: ToasterComponent,
        public fileService: FileService,
        public vcr: ViewContainerRef, public modal: NgbModal, public _global: Configuration) {
        this.toastr.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.recordService.isBIAdmin) {
            this.loadRecords();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedRFId == null) {
            this.selectedRFId = event.target.id;
        } else {
            this.selectedRFId = null;
        }
    }

    public closeDropDown(event){
        this.selectedRFId = null;
    }
    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;

        if (this.recordFormatReg != '') {
            this.searchPRecordFormat();
        } else {
            this.loadRecords();
        }
        this.setEndingPage(this.totalRecords);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalRecords / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadRecords();
    }

    public loadRecords() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.recordService.getDataByPage(BiUrls.RECORDFORMAT, self.pageNo,
                self.pageSize).then((res) => {
                    self.recordList = [];
                    self.totalPages = 0;
                    self.totalRecords = 0;
                    if (res != undefined) {
                        self.recordList = res.data != undefined &&
                            res.data.pageElements != undefined ? res.data.pageElements :
                            self.toastr.showError('No results found');
                        self.totalRecords = res.data != undefined &&
                            res.data.total != undefined ? res.data.total : 0;
                    }
                    self.setEndingPage(self.totalRecords);
                    self.loadDataSource();
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (error) => {
                    console.error(error);
                });
        });
    }

    // By Lalu
    public searchPRecordFormat() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            self.recordList = [];
            if (self.recordFormatReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.pageNo = 0;
            self.lastRegex = self.recordFormatReg;
            self.recordService.search(BiUrls.RECORDFORMAT, BiUrls.SEARCH_P_RECORDFORMAT,
                self.recordFormatReg, self.pageNo, self.pageSize).then((res) => {
                    self.loadSearchedPRecordFormat(res);
                    self.loader = false;
                }, (error) => {
                    console.error(error);
                });
            resolve('completed');
        })
    }

    // By Lalu
    public loadSearchedPRecordFormat(res) {
        let self = this;
        if (res != undefined) {
            self.recordList = res.data.pageElements;
            self.totalRecords = res.data.total;
        } else {
            self.totalRecords = 0;
        }
        self.setEndingPage(self.totalRecords);
    }

    public addNewRecord() {
        this.mainPage = false;
        this.recordPage = true;
        this.recordData = { id: null, name: '', description: '', deleted: 0 };
    }

    public loadDataSource() {
        return new Promise((resolve) => {
            let self = this;
            this.recordService.onStartUp(BiUrls.DATASOURCE).then((res) => {
                self.dataSourceList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    }

    public onSave() {
        let validate: any = this.validater();
        if (validate != '' || this.errorIndexD != null || this.errorIndexF != null) {
            this.toastr.showError(validate);
        } else {
            let self = this;
            self.isFieldEdit = [];
            self.saveButton = true;
            self.loader = true;
            self.recordData.recordFormatFieldData = self.recordFormatFieldData;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.recordService.update(BiUrls.RECORDFORMAT, self.recordData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.recordService.save(BiUrls.RECORDFORMAT, self.recordData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
        
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalRecords / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        let text = type == 'new' ?
            'Record Format saved successfully' :
            'Changes saved successfully';
        if (self.recordFormatReg != '') {
            self.searchPRecordFormat().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Record Format');
                }
            })
        } else {
            self.loadRecords().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Record Format');
                }
            }, (error) => {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.recordPage = false;
        self.isEdit = false;
        self.showField = false;
        self.loader = false;
        self.recordFormatFieldData = [];
    }

    public clickEdit(recordData) {
        let self = this;
        self.loader = true;
        self.selectedRFId = null;
        self.recordService.getDataById(BiUrls.RECORDFORMAT, recordData.id).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Record Format');
            } else {
                recordData = res.data;
                self.isEdit = true;
                self.mainPage = false;
                self.recordPage = true;
                self.recordData = JSON.parse(JSON.stringify(recordData));
                self.recordFormatFieldData = self.recordData.recordFormatFieldData;
            }
            self.loader = false;
        }, (error) => {
            console.error(error);
        });

    }

    public onBack() {
        this.mainPage = true;
        this.recordPage = false;
        this.recordData = {};
        this.isEdit = false;
        this.selectedRFId = null;
        this.recordFormatFieldData = [];
        this.showField = false;
        this.isFieldEdit = [];
        this.errorIndexD = null;
        this.errorIndexF = null;
    }

    public delete(record) {
        let self = this;
        self.loader = true;
        self.recordService.delete(BiUrls.RECORDFORMAT, record.id).then((response) => {
            self.pageNo = self.recordList.length == 1 ?
                self.totalRecords == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadRecords();
            self.loader = false;
            if (response.success) {
                self.toastr.showSuccess(record.name + ' removed successfully');
            } else {
                self.toastr.showError(!!response.message ? response.message : 'Unable to remove record format');
            }
        });
    }

    public removeRecord(record) {
        let r = confirm('Are you sure you want to remove the record format ' + record.name + ' ?');
        if (r == true) {
            this.delete(record);
        }
    }

    public validater() {
        if (this.recordData.name == undefined ||
            this.recordData.name.trim() == '') {
            return 'Please enter the name for record format';
        } else if (this.recordData.displayName == undefined ||
            this.recordData.displayName.trim() == '') {
            return 'Please enter the Display Name for record format';
        } else {
            this.recordData.name = this.recordData.name.trim();
            this.recordData.description = this.recordData.description != undefined ?
                this.recordData.description.trim() : null;
            this.recordData.recordFormatFieldData = this.recordFormatFieldData;
            return '';
        }
    }

    public addRecordFormatFields() {
        console.log('On Add Record Fields Controller ...');
        this.showField = true;
        this.recordFormatData = {
            fieldName: '', displayName: '', fieldDatatype: 'String',
            recordFormatId: null, deleted: 0
        };
        this.recordFormatData.recordFormatId = this.recordData.id;
    }

    public fieldValidater() {
        if (this.recordFormatData.fieldName == '' || this.recordFormatData.displayName == '' ||
            this.recordFormatData.fieldDatatype == '') {
            return 'Please enter values for all the fields';
        } else {
            return '';
        }
    }

    public addField() {
        let validate = this.fieldValidater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            this.recordFormatFieldData.push(this.recordFormatData);
            this.showField = false;
            this.recordFormatData = {};
        }
    }

    public onDeleteField(event, recordField) {
        console.log('On Delete Field COntroller ...');
        let r = confirm('Are you sure you want to delete this filed ' +
            recordField.displayName + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Field removed successfully');
            let index = this.recordFormatFieldData.indexOf(recordField);
            this.recordFormatFieldData.splice(index, 1);
        }
    }

    public selectDataSource(event) {
        if (event.target.value != undefined && event.target.value != 'none') {
            this.recordData['dataSourceId'] = event.target.value;
        } else {
            this.recordData['dataSourceId'] = null;
        }
    }

    public syncRecordFormat(rf) {
        let self = this;
        self.selectedRFId = null;
        let r = confirm('Are you sure you want to sync ' + rf.name + ' ?');
        if (r) {
            self.recordService.syncRecordFormat(rf.id).then((res) => {
                if (res.success && res.message) {
                    self.toastr.showSuccess(res.message);
                } else if (res.success) {
                    self.toastr.showSuccess('Sync was successful');
                } else if (res.message) {
                    self.toastr.showError(res.message);
                } else if (res.errorMessage != undefined) {
                    self.toastr.showError(res.errorMessage);
                } else {
                    self.toastr.showError('Unable to sync data with model');
                }
            });
        }
    }

    uploadFile(type, recordFormat) {
        let activeModal = this.modal.open(FileUploader);
        activeModal.componentInstance.parent = this;
        if (type == 'reUpLoad') {
            this.selectedRFId = null;
            activeModal.componentInstance.reUpload = true;
            activeModal.componentInstance.recordFormat = recordFormat.id;

        }
    }

    closeActionsMenu(e){
        this.selectedRFId = null;
    }

    selectPrimaryKey(isPk,rffId){
        this.recordFormatFieldData.forEach(rff => {
            if(rff.id == rffId){
                rff.isPK = isPk;
            }else{
                rff.isPK = false;
            }
        });
    }

    onEditPrevField(rff, i){
        if(this.errorIndexD != null || this.errorIndexF != null){
            this.toastr.showError('Please enter values for all the fields');
            return;
        }
        this.isFieldEdit = Array(this.recordFormatFieldData.length).fill(false);
        this.isFieldEdit[i] = !this.isFieldEdit[i];        
        let index = this.recordFormatFieldData.indexOf(rff);
        this.recordFormatData = {
            fieldName: rff.fieldName, displayName: rff.displayName, fieldDatatype: rff.fieldDatatype,
            deleted: 0 ,fieldSize: rff.fieldSize, id: rff.id, isPK: rff.isPK, recordFormatId: rff.recordFormatId,
            refId: rff.refId
        };
        if(rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date'){
            this.recordFormatData.dateFormat = rff.dateFormat ? rff.dateFormat : 'YYYY-MM-DD';
        }else if(rff.fieldDatatype == 'DATETIME'){
            this.recordFormatData.dateFormat = rff.dateFormat ? rff.dateFormat : 'YYYY-MM-DD HH:MM:SS';
        } else{
            delete this.recordFormatData.dateFormat;
        }
        this.recordFormatFieldData[index] = this.recordFormatData;
        this.recordFormatData = {}; 
    }

    onValidateEdit(rff,i){
        this.errorIndexD = rff.displayName == '' ? i : null;
        this.errorIndexF = rff.fieldName == '' ? i : null;
    }

    setFieldDatatype(fieldDatatype,rff){
        let index = this.recordFormatFieldData.indexOf(rff);
        this.recordFormatFieldData[index].fieldDatatype= fieldDatatype;
        if(rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date'){
            this.recordFormatFieldData[index].dateFormat = 'YYYY-MM-DD';
        }else if(rff.fieldDatatype == 'DATETIME'){
            this.recordFormatFieldData[index].dateFormat = 'YYYY-MM-DD HH:MM:SS';
        } else{
            delete this.recordFormatFieldData[index].dateFormat;
        }
    }

    downloadFile(rf) {
        this.selectedRFId = null;
        let type = rf.recordFormatType ? rf.recordFormatType : "csv";
        this.fileService.download(this.downloadUrl + "/" + rf.id, rf.name + '.' + type, type);
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/recordFormat.component.ts